import { find, get, isEmpty } from 'lodash'
import sitesConfig from '../../../config/sites/'
import categoriesConfig from '../../../config/sites/categories/'

import { ISearchResults } from '../../../typings/searchResults'
import {
  IGetRecommendedSearchesByCategoryResultsFailAction,
  IGetRecommendedSearchesByCategoryResultsSuccessAction,
  TypeKeys
} from '../searchPage'

const recommendationsLimit = sitesConfig.defaults.recommendations_limit

const rootCategoryRecommendations = (
  results: ISearchResults,
  rootCategoryPaths: string[]
): string[] => {
  const tagAggregations = get(results, 'aggregations.tags')
  if (isEmpty(tagAggregations)) {
    return []
  } else {
    const lowercasedRootCategories = rootCategoryPaths.map(category => {
      return category.toLowerCase()
    })

    const recommendations = []
    let index = 0
    while (recommendations.length < recommendationsLimit) {
      const tag = tagAggregations[index]
      if (!tag) {
        break
      }
      if (!lowercasedRootCategories.includes(tag.key)) {
        recommendations.push(tag.key)
      }
      index++
    }
    return recommendations
  }
}

const fetchRecommendedSearchesByCategoryResults = (
  query: any,
  results: ISearchResults,
  currentSite: string
) => {
  const siteRootCategories = categoriesConfig[currentSite]
  const siteRootCategoryPaths = siteRootCategories.reduce(
    (paths: string[], category: any) => {
      paths.push(category.path)
      return paths
    },
    []
  )

  if (siteRootCategoryPaths.includes(query.category)) {
    const rootCategory = find(siteRootCategories, {
      path: query.category
    }) as any
    const action: IGetRecommendedSearchesByCategoryResultsSuccessAction = {
      type: TypeKeys.GET_RECOMMENDED_SEARCHES_BY_CATEGORY_RESULTS_SUCCESS,
      payload: {
        type: 'tags',
        recommendations: rootCategoryRecommendations(
          results,
          siteRootCategoryPaths
        ),
        hint: rootCategory.name
      }
    }
    return action
  } else {
    const action: IGetRecommendedSearchesByCategoryResultsFailAction = {
      type: TypeKeys.GET_RECOMMENDED_SEARCHES_BY_CATEGORY_RESULTS_FAIL
    }
    return action
  }
}

export default fetchRecommendedSearchesByCategoryResults



// WEBPACK FOOTER //
// ./common/actions/search/fetchRecommendedSearchesByCategoryResults.ts